<div class="main">
  <h2>Cementaciones en ICP</h2>

  <div style="min-height: 50vh; width: 100vw" *ngIf="isLoading">
    <div class="loading-shade">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div class="container" *ngIf="!isLoading">
    <table mat-table [dataSource]="cementingsIcp" class="cementings-icp">
      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef> Fecha Int </mat-header-cell>
        <mat-cell *matCellDef="let c">
          {{ c.startDate | date : "dd/MM/yyyy" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="top">
        <mat-header-cell *matHeaderCellDef> Tope [m] </mat-header-cell>
        <mat-cell *matCellDef="let c">
          {{ c.top | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="base">
        <mat-header-cell *matHeaderCellDef> Base [m] </mat-header-cell>
        <mat-cell *matCellDef="let c">
          {{ c.base | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="result">
        <mat-header-cell *matHeaderCellDef> Resultado </mat-header-cell>
        <mat-cell *matCellDef="let c">
          {{ c.result }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="noData">
        <mat-footer-cell *matFooterCellDef colspan="4">
          <div class="footer">
            <div class="footer-no-data">No se encontraron datos.</div>
            <div class="footer-no-data-origin">
              De existir datos en el sistema de origen, podrás visualizarlos
              acá.
            </div>
          </div>
        </mat-footer-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
      ></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      <mat-footer-row
        *matFooterRowDef="['noData']"
        [ngClass]="{ 'hide-footer': hideFooter }"
      ></mat-footer-row>
    </table>
  </div>
</div>
